// removed by extract-text-webpack-plugin
module.exports = {"root":"LoginScreen__root___11hr4","wrapper":"LoginScreen__wrapper___29YaG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginScreen/LoginScreen.scss
// module id = 1033
// module chunks = 0